function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronDown, faExternalLinkAlt, faBars, faDownload, faExclamationCircle, faTimes, faEdit, faTrash, faCheck, faPlus, faLevelUpAlt, faUserCircle, faUserPlus, faAngleDown, faAngleUp, faAngleLeft, faMinus } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFontAwesome } from '@fortawesome/free-brands-svg-icons';
import { useTheme } from '@emotion/react';
const icons = {
  'fa-arrow-right': faArrowRight,
  'fa-chevron-down': faChevronDown,
  'fa-external-link-alt': faExternalLinkAlt,
  'fa-bars': faBars,
  'fa-download': faDownload,
  'fa-exclamation-circle': faExclamationCircle,
  'fa-times': faTimes,
  'fa-trash': faTrash,
  'fa-edit': faEdit,
  'fa-check': faCheck,
  'fa-plus': faPlus,
  'fa-level-up-alt': faLevelUpAlt,
  'fa-user-circle': faUserCircle,
  'fa-user-plus': faUserPlus,
  'fa-angle-down': faAngleDown,
  'fa-angle-up': faAngleUp,
  'fa-angle-left': faAngleLeft,
  'fa-twitter': faTwitter,
  'fa-font-awesome': faFontAwesome,
  'fa-minus': faMinus
};
export const FontAwesomeIcon = ({
  icon,
  color,
  ...restProps
}) => {
  const theme = useTheme();
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Icon, _extends({
      icon: icons[icon],
      color: color || theme.primaryColor
    }, restProps))
  );
};
FontAwesomeIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string
};
FontAwesomeIcon.defaultProps = {
  color: ''
};